import { render, staticRenderFns } from "./ServiceActionFormModal.vue?vue&type=template&id=1324c22a"
import script from "./ServiceActionFormModal.vue?vue&type=script&lang=js"
export * from "./ServiceActionFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports